import { render, staticRenderFns } from "./KYC_v2.vue?vue&type=template&id=bed02acc&scoped=true&"
import script from "./KYC_v2.vue?vue&type=script&lang=js&"
export * from "./KYC_v2.vue?vue&type=script&lang=js&"
import style0 from "./KYC_v2.vue?vue&type=style&index=0&id=bed02acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed02acc",
  null
  
)

export default component.exports